import { render, staticRenderFns } from "./wsClientSideEx.vue?vue&type=template&id=7a2a5770&scoped=true&"
import script from "./wsClientSideEx.vue?vue&type=script&lang=js&"
export * from "./wsClientSideEx.vue?vue&type=script&lang=js&"
import style0 from "./wsClientSideEx.vue?vue&type=style&index=0&id=7a2a5770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a5770",
  null
  
)

export default component.exports